export const environment = {
    apiBaseUrl: "https://dev.api.yoid.info/api-client/v1",
    apiPsd2BaseUrl: "https://dev.api.yoid.info/api-psd2/v1",
    debug: true
};
